import gql from 'graphql-tag';
import { HasSharedWithFragment } from 'services/apollo/fragments/coreFragments';

export const GroupFeedFragment = gql`
  fragment groupFeedResults on ActivityFeedSearch {
    nodes {
      ... on Node {
        id
        integrationType
        title
        baseUrl
        url
        modified
        created
        category
        pins
        owners {
          id
          name
          email
          avatarUrl
        }
        ...hasSharedWith
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ${HasSharedWithFragment}
`;

export const GroupMemberFragment = gql`
  fragment groupMemberResults on Group {
    members {
      ... on Person {
        id
        name
        email
        avatarUrl
      }
    }
  }
`;
